import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaInstagram, FaWhatsapp, FaApple } from "react-icons/fa";
import { IoMailSharp } from "react-icons/io5";
import { RiFacebookCircleLine } from "react-icons/ri";
import { message, Modal, Form, Input } from "antd";
import { useLoading } from "../../Services/loadingService";
import { useParams } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import defaultimage from "../../Assets/Images/Notfound.png";
import { FaGooglePlay } from "react-icons/fa6";
import { Theme001, Theme002, Theme003, Theme004 } from "./ThemeLayout";
import { logInstance } from "../../AxiosConfig";
const ProfileCard = () => {
  const [cardsData, setCardsData] = useState([]);

  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams();

  // Manage flip state for multiple cards
  const [flippedCards, setFlippedCards] = useState({});

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const handleFlip = (cardId) => {
    setFlippedCards((prev) => ({
      ...prev,
      [cardId]: !prev[cardId],
    }));
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    setFormLoading(true);
    const payload = {
      userId: cardsData.userId, // Assuming userId is available in cardsData
      name: values.name,
      phnNumber: values.phnNumber,
    };

    logInstance
      .post("/profile-form/submit", payload)
      .then((response) => {
        message.success("Contact shared successfully!");
        setIsModalVisible(false);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        message.error("Failed to share contact. Please try again.");
      })
      .finally(() => setFormLoading(false));
  };

  const fetchCardsData = () => {
    startLoading();
    logInstance
      .get(`/card/cardId/${id}`)
      .then((response) => {
        console.log("response", response);
        setCardsData(response?.data?.card || []);
      })
      .catch((error) => {
        console.error("Error fetching Data:", error);
      })
      .finally(() => stopLoading());
  };

  useEffect(() => {
    fetchCardsData();
  }, []);
  const generateVCF = () => {
    if (!cardsData) return;

    const yourName = cardsData.yourName || "No Name Available";
    const businessName = cardsData.businessName || "";
    const designation = cardsData.designation || "";
    const mobile = cardsData.mobile || "";
    const whatsapp = cardsData.whatsappNo || "";
    const email = cardsData.email || "";
    const website = cardsData.website ? `https://${cardsData.website}` : "";
    const fullName =
      [yourName, designation, businessName].filter(Boolean).join(" ") ||
      "No Name Available";
    const vcfData = `
BEGIN:VCARD
VERSION:3.0
N:${fullName}
FN:${fullName}
ORG:${businessName}
TITLE:${designation}
TEL;TYPE=CELL:${mobile}
${whatsapp ? `TEL;TYPE=WHATSAPP:${whatsapp}` : ""}
EMAIL:${email}
${website ? `URL:${website}` : ""}
END:VCARD
  `.trim();

    const blob = new Blob([vcfData], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${fullName}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleLinkClick = (event, link) => {
    if (!link) {
      event.preventDefault();
      message.error("Not Found");
    }
  };
  const themeLayouts = {
    "001": Theme001,
    "002": Theme002,
    "003": Theme003,
    "004": Theme004,
  };
  return (
    <div className="cards-container">
      {cardsData && (
        <div className="business-card" key={cardsData._id}>
          <div className="business-card-first-container">
            <h1 className="business-card-first-container-headtext">
              {cardsData.businessName || "Name"}
            </h1>
          </div>

          <div
            className="flip-container "
            onClick={() => handleFlip(cardsData._id)}
          >
            <div
              className={`flipper ${flippedCards[cardsData._id] ? "flipped" : ""
                }`}
            >
              {(() => {
                const ThemeComponent =
                  themeLayouts[cardsData.theme] || Theme001;
                return (
                  <ThemeComponent
                    cardsData={cardsData}
                    defaultimage={defaultimage}
                  />
                );
              })()}
            </div>
          </div>

          <div className="business-contact-details">
            <h4 className="name">
              {[
                cardsData.yourName,
                cardsData.designation,
                cardsData.businessName,
              ]
                .filter(Boolean) // removes undefined, null, or empty strings
                .join(" ") || "No Name Available"}
            </h4>

            {/* <h5 className="position">
              {cardsData.designation || "No Designation Available"}
            </h5> */}
            <hr
              style={{
                height: "2px",
                border: "none",
                margin: "15px 10px",
                background: "linear-gradient(to right, #2986D6, #2B4962)",
              }}
            />

            <div>
              <a
                href={`tel:${cardsData.mobile}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="user-phone">
                  <FaPhoneAlt />
                  {cardsData.mobile || "+91 00000 00000"}
                </p>
              </a>

              <a
                href={`mailto:${cardsData.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="user-email">
                  <IoMailSharp />
                  {cardsData.email || "No email available"}
                </p>
              </a>
            </div>
            <div className="button-group">
              <button className="save-contact" onClick={generateVCF}>
                SAVE CONTACT
              </button>
              <button className="share-contact" onClick={showModal}>
                SHARE CONTACT
              </button>
            </div>
            <hr
              style={{
                height: "2px",
                border: "none",
                background: "linear-gradient(to right, #2986D6, #2B4962)",
                margin: "15px 10px",
              }}
            />
          </div>

          <div className="business-card-services-list2">
            <h3>🔹Why Use KC (Know Connections)!</h3>
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {[
                {
                  icon: "🔗",
                  text: "Effortless Contact Sharing & Organization",
                },
                { icon: "👥", text: "Stay Connected with Your Network & Team" },
                {
                  icon: "📊",
                  text: "Smart Contact Management for Business Growth",
                },
              ].map((item, index) => (
                <li key={index}>
                  <span className="icon1">{item.icon}</span>{" "}
                  <span className="text">{item.text}</span>
                </li>
              ))}
            </ul>
            <ul
              className="second-ul"
              style={{ listStyle: "none", paddingLeft: 0 }}
            >
              {[
                {
                  icon: "📩",
                  text: `Join ${cardsData.businessName} Today & Simplify Networking!`,
                },
                { icon: "🤝", text: "Let's stay in touch and grow together!" },
              ].map((item, index) => (
                <li key={index}>
                  <span className="icon1">{item.icon}</span>
                  <span className="text">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="available-storess">
            <h2>Download App</h2>
            <div className="available-stores mt-2">
              <div className="d-flex gap-4 justify-content-center">
                <a
                  href="https://play.google.com/store/apps/details?id=apps.knowconnections.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="google-playstores">
                    <div className="icon-stores">
                      <FaGooglePlay />
                    </div>
                    <div className="content-stores">
                      <span>Get it On</span>
                      <h4>Google play</h4>
                    </div>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/in/app/know-connections/id6741457754"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="apple-stores">
                    <div className="icon-stores">
                      <FaApple />
                    </div>
                    <div className="content-stores">
                      <span>Download On the</span>
                      <h4>App Store</h4>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div>
            <div className="firstend-container">
              <span className="footer-icons">
                <a
                  href={
                    cardsData.whatsappNo
                      ? `https://wa.me/${cardsData.whatsappNo}`
                      : "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleLinkClick(e, cardsData.whatsappNo)}
                >
                  <FaWhatsapp />
                </a>

                <a
                  href={cardsData.facebookLink || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleLinkClick(e, cardsData.facebookLink)}
                >
                  <RiFacebookCircleLine />
                </a>

                <a
                  href={cardsData.instagramLink || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleLinkClick(e, cardsData.instagramLink)}
                >
                  <FaInstagram />
                </a>

                <a
                  href={cardsData.twitterLink || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleLinkClick(e, cardsData.twitterLink)}
                >
                  <FaLinkedin />
                </a>
              </span>
            </div>
            <div className="secondend-container">
              <p className="secondtext">
                "Invite friends and family to KC (Know Connections) - seamless
                connections when you have everyone on KC (Know Connections)"
              </p>
            </div>
          </div>
        </div>
      )}

      <Modal
        title="Share Your Contact"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ name: "", phnNumber: "" }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phnNumber"
            rules={[
              { required: true, message: "Please enter your phone number" },
              { pattern: /^\d{10}$/, message: "Please enter a valid 10-digit phone number" }
            ]}
          >
            <Input placeholder="Enter your phone number" />
          </Form.Item>
          <Form.Item>
            <button
              type="submit"
              className="save-contact"
              style={{ width: "100%", marginTop: "10px" }}
              disabled={formLoading}
            >
              {formLoading ? "Submitting..." : "Submit"}
            </button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ProfileCard;
